/* eslint-disable no-unused-vars */
import store from '@/store'
import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'history',
})

router.beforeEach((to, from, next) => {
  if (!to.query.preview && store.getters.externalQuery.preview) {
    const previewQuery = { preview: true }
    next({
      path: to.path,
      query: previewQuery,
    })
  } else {
    next()
  }
})

export default router
